/* eslint-disable no-console */
export const logLoggerFailure = (logLevel) => {
    console.warn(`[Logger] Failed to log ${logLevel} message`);
};
